module.exports = __webpack_public_path__ + "static/screen2-43093c4ea358def74ba68f957bacba77.webp";